import { createFileRoute } from "@tanstack/react-router";
import { BlackFridayLanding } from "@/components/BlackFridayLanding";

const title = "Black Friday 2026: Custom 5-Page Website $1,250 | Colorado Web Impressions";
const description = "Black Friday 2026 special: a custom, SEO-ready 5-page website for $1,250 with 1 year of web hosting included. Extra pages $85 each. Ends Cyber Monday, Nov 30, 2026.";

export const Route = createFileRoute("/black-friday-website")({
  head: () => ({ meta: [
    { title }, { name: "description", content: description },
    { property: "og:title", content: title }, { property: "og:description", content: description },
    { property: "og:type", content: "website" }, { name: "twitter:card", content: "summary_large_image" },
  ] }),
  component: () => <BlackFridayLanding offer={{
    slug: "black-friday-website",
    eyebrow: "Black Friday 2026 Special",
    headline: "Custom 5-Page Website",
    price: "$1,250",
    exclusivity: "New customers only",
    subhead: "Our Starter package at a Black Friday price: a custom-built website for your Colorado business, not a template, with hosting covered for a full year. First-time clients only — offer ends Cyber Monday, November 30, 2026.",
    includes: ["5 custom-designed pages", "SEO ready and built to rank on Google", "1 year of web hosting included", "Additional pages just $85 each", "Mobile-friendly and fast loading", "Built by Chris, not outsourced", "No ecommerce at this price — ask us about online stores"],
    topic: "Black Friday 2026: Custom 5-Page Website $1,250",
  }} />,
});
